import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/fitness_statistics/download_pdf_ecr_distinct_list";

export class DownloadEcrListCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
        this.responseType = "blob";
    }

    public async execute(): Promise<AxiosResponse> {
        console.log("DownloadEcrListCommand.execute()");
        return await this.executeCommand();
    }
}
